export default {
    props: {
        totalPages: { type: Number, required: true },
    },
    computed: {
        nextPage() {
            if (this.currentPage < this.totalPages)
                return this.currentPage + 1;
        },
        previousPage() {
            if (this.currentPage > 1)
                return this.currentPage - 1;
        },
        pageLinks() {
            return this.getPageLinks();
        },
    },
    methods: {
        // This follows the logic in Laravel's paginator (class: UrlWindow)
        getPageLinks(onEachSide = 3) {
            if (this.totalPages < (onEachSide * 2) + 6)
                return this.getSmallSlider();

            let parts = this.getUrlSlider(onEachSide);
            let result = [...parts.first];
            if (parts.slider) {
                result.push('...');
                result = result.concat(parts.slider);
            }
            result.push('...');
            result = result.concat(parts.last);
            return result;
        },
        getSmallSlider() {
            return _.range(1, this.totalPages + 1);
        },
        getUrlSlider(onEachSide) {
            let sliderWindow = onEachSide * 2;

            if (this.currentPage <= sliderWindow)
                return this.getSliderTooCloseToBeginning(sliderWindow);

            if (this.currentPage > (this.totalPages - sliderWindow))
                return this.getSliderTooCloseToEnding(sliderWindow);

            return this.getFullSlider(onEachSide);
        },
        getSliderTooCloseToBeginning(sliderWindow) {
            return {
                first: _.range(1, sliderWindow + 2 + 1),
                slider: null,
                last: this.getFinish(),
            };
        },
        getSliderTooCloseToEnding(sliderWindow) {
            return {
                first: this.getStart(),
                slider: null,
                last: _.range(this.totalPages - (sliderWindow + 2), this.totalPages + 1),
            };
        },
        getFullSlider(onEachSide) {
            return {
                first: this.getStart(),
                slider: this.getAdjacentUrlRange(onEachSide),
                last: this.getFinish(),
            };
        },
        getAdjacentUrlRange(onEachSide) {
            return _.range(this.currentPage - onEachSide, this.currentPage + onEachSide + 1);
        },
        getStart() {
            return [1, 2];
        },
        getFinish() {
            return [this.totalPages - 1, this.totalPages];
        },
    }
}
